// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsersRouteImport } from './routes/users'
import { Route as Setup2faRouteImport } from './routes/setup-2fa'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as MaintenanceRouteImport } from './routes/maintenance'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ConfigRouteImport } from './routes/config'
import { Route as ComingSoonRouteImport } from './routes/coming-soon'
import { Route as R404RouteImport } from './routes/404'
import { Route as R401RouteImport } from './routes/401'
import { Route as SettingsRouteRouteImport } from './routes/settings/route'
import { Route as HrRouteRouteImport } from './routes/hr/route'
import { Route as DashboardRouteRouteImport } from './routes/dashboard/route'
import { Route as CrmRouteRouteImport } from './routes/crm/route'
import { Route as AuthRouteRouteImport } from './routes/auth/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as MModuleKeyRouteRouteImport } from './routes/m/$moduleKey/route'
import { Route as SettingsQuotasRouteImport } from './routes/settings/quotas'
import { Route as SettingsMarketplaceRouteImport } from './routes/settings/marketplace'
import { Route as SettingsRolesRouteRouteImport } from './routes/settings/roles/route'
import { Route as SettingsApiKeysRouteRouteImport } from './routes/settings/api-keys/route'
import { Route as HrIndexRouteImport } from './routes/hr/index'
import { Route as HrTrainingRouteRouteImport } from './routes/hr/training/route'
import { Route as HrShiftsRouteRouteImport } from './routes/hr/shifts/route'
import { Route as HrRecruitmentRouteRouteImport } from './routes/hr/recruitment/route'
import { Route as HrPerformanceReviewsRouteRouteImport } from './routes/hr/performance-reviews/route'
import { Route as HrPayrollRouteRouteImport } from './routes/hr/payroll/route'
import { Route as HrOnboardingRouteRouteImport } from './routes/hr/onboarding/route'
import { Route as HrMeRouteRouteImport } from './routes/hr/me/route'
import { Route as HrLifecycleRouteRouteImport } from './routes/hr/lifecycle/route'
import { Route as HrLeaveRouteRouteImport } from './routes/hr/leave/route'
import { Route as HrExpenseClaimsRouteRouteImport } from './routes/hr/expense-claims/route'
import { Route as HrEmployeesRouteRouteImport } from './routes/hr/employees/route'
import { Route as HrDocumentsRouteRouteImport } from './routes/hr/documents/route'
import { Route as HrDepartmentsRouteRouteImport } from './routes/hr/departments/route'
import { Route as HrContractsRouteRouteImport } from './routes/hr/contracts/route'
import { Route as HrAttendanceRouteRouteImport } from './routes/hr/attendance/route'
import { Route as CrmIndexRouteImport } from './routes/crm/index'
import { Route as CrmOpportunitiesRouteRouteImport } from './routes/crm/opportunities/route'
import { Route as CrmLeadsRouteRouteImport } from './routes/crm/leads/route'
import { Route as CrmContactsRouteRouteImport } from './routes/crm/contacts/route'
import { Route as CrmActivitiesRouteRouteImport } from './routes/crm/activities/route'
import { Route as CrmAccountsRouteRouteImport } from './routes/crm/accounts/route'
import { Route as MModuleKeyIndexRouteImport } from './routes/m/$moduleKey/index'
import { Route as SettingsTeamsIndexRouteImport } from './routes/settings/teams/index'
import { Route as SettingsModulesIndexRouteImport } from './routes/settings/modules/index'
import { Route as SettingsCustomModulesIndexRouteImport } from './routes/settings/custom-modules/index'
import { Route as SettingsCalculationsIndexRouteImport } from './routes/settings/calculations/index'
import { Route as SettingsTeamsTeamIdRouteImport } from './routes/settings/teams/$teamId'
import { Route as SettingsCustomModulesNewRouteImport } from './routes/settings/custom-modules/new'
import { Route as SettingsCrmWebhooksRouteImport } from './routes/settings/crm/webhooks'
import { Route as SettingsCrmPipelinesRouteImport } from './routes/settings/crm/pipelines'
import { Route as SettingsCrmLookupsRouteImport } from './routes/settings/crm/lookups'
import { Route as SettingsCrmCurrencySettingsRouteImport } from './routes/settings/crm/currency-settings'
import { Route as SettingsCrmCurrencyRatesRouteImport } from './routes/settings/crm/currency-rates'
import { Route as SettingsCalculationsNewRouteImport } from './routes/settings/calculations/new'
import { Route as SettingsCalculationsKeyRouteImport } from './routes/settings/calculations/$key'
import { Route as SettingsCustomModulesKeyRouteRouteImport } from './routes/settings/custom-modules/$key/route'
import { Route as SettingsRolesIndexRouteImport } from './routes/settings/roles/index'
import { Route as SettingsRolesUsersRouteImport } from './routes/settings/roles/users'
import { Route as SettingsRolesNewRouteImport } from './routes/settings/roles/new'
import { Route as SettingsRolesRoleKeyRouteImport } from './routes/settings/roles/$roleKey'
import { Route as SettingsApiKeysIndexRouteImport } from './routes/settings/api-keys/index'
import { Route as SettingsApiKeysAuditRouteImport } from './routes/settings/api-keys/audit'
import { Route as HrTrainingIndexRouteImport } from './routes/hr/training/index'
import { Route as HrTrainingEventIdRouteImport } from './routes/hr/training/$eventId'
import { Route as HrShiftsIndexRouteImport } from './routes/hr/shifts/index'
import { Route as HrRecruitmentIndexRouteImport } from './routes/hr/recruitment/index'
import { Route as HrRecruitmentOpeningsRouteRouteImport } from './routes/hr/recruitment/openings/route'
import { Route as HrPerformanceReviewsReviewIdRouteImport } from './routes/hr/performance-reviews/$reviewId'
import { Route as HrPayrollIndexRouteImport } from './routes/hr/payroll/index'
import { Route as HrPayrollComponentsRouteImport } from './routes/hr/payroll/components'
import { Route as HrPayrollStructuresRouteRouteImport } from './routes/hr/payroll/structures/route'
import { Route as HrPayrollRunsRouteRouteImport } from './routes/hr/payroll/runs/route'
import { Route as HrMeIndexRouteImport } from './routes/hr/me/index'
import { Route as HrMeProfileRouteImport } from './routes/hr/me/profile'
import { Route as HrMePerformanceRouteImport } from './routes/hr/me/performance'
import { Route as HrMePayslipsRouteImport } from './routes/hr/me/payslips'
import { Route as HrMeLeaveRouteImport } from './routes/hr/me/leave'
import { Route as HrMeExpenseClaimsRouteImport } from './routes/hr/me/expense-claims'
import { Route as HrMeAttendanceRouteImport } from './routes/hr/me/attendance'
import { Route as HrLifecycleIndexRouteImport } from './routes/hr/lifecycle/index'
import { Route as HrExpenseClaimsIndexRouteImport } from './routes/hr/expense-claims/index'
import { Route as HrExpenseClaimsClaimIdRouteImport } from './routes/hr/expense-claims/$claimId'
import { Route as HrEmployeesIndexRouteImport } from './routes/hr/employees/index'
import { Route as HrEmployeesEmployeeIdRouteImport } from './routes/hr/employees/$employeeId'
import { Route as HrDocumentsIndexRouteImport } from './routes/hr/documents/index'
import { Route as HrContractsIndexRouteImport } from './routes/hr/contracts/index'
import { Route as HrContractsContractIdRouteImport } from './routes/hr/contracts/$contractId'
import { Route as HrAttendanceIndexRouteImport } from './routes/hr/attendance/index'
import { Route as HrAttendanceMarkRouteImport } from './routes/hr/attendance/mark'
import { Route as CrmOpportunitiesIndexRouteImport } from './routes/crm/opportunities/index'
import { Route as CrmOpportunitiesNewRouteImport } from './routes/crm/opportunities/new'
import { Route as CrmOpportunitiesOpportunityIdRouteImport } from './routes/crm/opportunities/$opportunityId'
import { Route as CrmLeadsIndexRouteImport } from './routes/crm/leads/index'
import { Route as CrmLeadsNewRouteImport } from './routes/crm/leads/new'
import { Route as CrmLeadsImportRouteImport } from './routes/crm/leads/import'
import { Route as CrmLeadsLeadIdRouteImport } from './routes/crm/leads/$leadId'
import { Route as CrmContactsIndexRouteImport } from './routes/crm/contacts/index'
import { Route as CrmContactsNewRouteImport } from './routes/crm/contacts/new'
import { Route as CrmContactsContactIdRouteImport } from './routes/crm/contacts/$contactId'
import { Route as CrmActivitiesIndexRouteImport } from './routes/crm/activities/index'
import { Route as CrmAccountsIndexRouteImport } from './routes/crm/accounts/index'
import { Route as CrmAccountsNewRouteImport } from './routes/crm/accounts/new'
import { Route as CrmAccountsAccountIdRouteImport } from './routes/crm/accounts/$accountId'
import { Route as MModuleKeyEntityKeyIndexRouteImport } from './routes/m/$moduleKey/$entityKey/index'
import { Route as MModuleKeyEntityKeyNewRouteImport } from './routes/m/$moduleKey/$entityKey/new'
import { Route as SettingsCalculationsKeyRunRouteImport } from './routes/settings/calculations/$key.run'
import { Route as SettingsCustomModulesKeyIndexRouteImport } from './routes/settings/custom-modules/$key/index'
import { Route as SettingsCustomModulesKeyWebhooksRouteImport } from './routes/settings/custom-modules/$key/webhooks'
import { Route as SettingsCustomModulesKeyPermissionsRouteImport } from './routes/settings/custom-modules/$key/permissions'
import { Route as SettingsCustomModulesKeyNavRouteImport } from './routes/settings/custom-modules/$key/nav'
import { Route as SettingsCustomModulesKeyAuditRouteImport } from './routes/settings/custom-modules/$key/audit'
import { Route as HrRecruitmentApplicantsApplicantIdRouteImport } from './routes/hr/recruitment/applicants/$applicantId'
import { Route as HrRecruitmentOpeningsIndexRouteImport } from './routes/hr/recruitment/openings/index'
import { Route as HrRecruitmentOpeningsOpeningIdRouteImport } from './routes/hr/recruitment/openings/$openingId'
import { Route as HrPayrollStructuresIndexRouteImport } from './routes/hr/payroll/structures/index'
import { Route as HrPayrollStructuresStructureIdRouteImport } from './routes/hr/payroll/structures/$structureId'
import { Route as HrPayrollRunsIndexRouteImport } from './routes/hr/payroll/runs/index'
import { Route as HrPayrollRunsRunIdRouteImport } from './routes/hr/payroll/runs/$runId'
import { Route as CrmOpportunitiesOpportunityIdEditRouteImport } from './routes/crm/opportunities/$opportunityId.edit'
import { Route as CrmLeadsLeadIdEditRouteImport } from './routes/crm/leads/$leadId.edit'
import { Route as CrmLeadsLeadIdConvertRouteImport } from './routes/crm/leads/$leadId.convert'
import { Route as CrmContactsContactIdEditRouteImport } from './routes/crm/contacts/$contactId.edit'
import { Route as CrmAccountsAccountIdEditRouteImport } from './routes/crm/accounts/$accountId.edit'
import { Route as MModuleKeyEntityKeyRecordIdIndexRouteImport } from './routes/m/$moduleKey/$entityKey/$recordId/index'
import { Route as MModuleKeyEntityKeyRecordIdEditRouteImport } from './routes/m/$moduleKey/$entityKey/$recordId/edit'
import { Route as SettingsExtensionsModuleKeyEntityKeyViewsRouteImport } from './routes/settings/extensions/$moduleKey/$entityKey/views'
import { Route as SettingsExtensionsModuleKeyEntityKeyLayoutRouteImport } from './routes/settings/extensions/$moduleKey/$entityKey/layout'
import { Route as SettingsExtensionsModuleKeyEntityKeyFieldsRouteImport } from './routes/settings/extensions/$moduleKey/$entityKey/fields'
import { Route as SettingsCustomModulesKeyWorkflowsIndexRouteImport } from './routes/settings/custom-modules/$key/workflows/index'
import { Route as SettingsCustomModulesKeyEntitiesIndexRouteImport } from './routes/settings/custom-modules/$key/entities/index'
import { Route as SettingsCustomModulesKeyWorkflowsNewRouteImport } from './routes/settings/custom-modules/$key/workflows/new'
import { Route as SettingsCustomModulesKeyWorkflowsWorkflowKeyRouteImport } from './routes/settings/custom-modules/$key/workflows/$workflowKey'
import { Route as SettingsCustomModulesKeyEntitiesNewRouteImport } from './routes/settings/custom-modules/$key/entities/new'
import { Route as SettingsCustomModulesKeyEntitiesEntityKeyRouteImport } from './routes/settings/custom-modules/$key/entities/$entityKey'

const UsersRoute = UsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => rootRouteImport
          })
const Setup2faRoute = Setup2faRouteImport.update({
            id: '/setup-2fa',path: '/setup-2fa',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const RegisterRoute = RegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => rootRouteImport
          })
const MaintenanceRoute = MaintenanceRouteImport.update({
            id: '/maintenance',path: '/maintenance',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const ConfigRoute = ConfigRouteImport.update({
            id: '/config',path: '/config',getParentRoute: () => rootRouteImport
          })
const ComingSoonRoute = ComingSoonRouteImport.update({
            id: '/coming-soon',path: '/coming-soon',getParentRoute: () => rootRouteImport
          })
const R404Route = R404RouteImport.update({
            id: '/404',path: '/404',getParentRoute: () => rootRouteImport
          })
const R401Route = R401RouteImport.update({
            id: '/401',path: '/401',getParentRoute: () => rootRouteImport
          })
const SettingsRouteRoute = SettingsRouteRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const HrRouteRoute = HrRouteRouteImport.update({
            id: '/hr',path: '/hr',getParentRoute: () => rootRouteImport
          })
const DashboardRouteRoute = DashboardRouteRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const CrmRouteRoute = CrmRouteRouteImport.update({
            id: '/crm',path: '/crm',getParentRoute: () => rootRouteImport
          })
const AuthRouteRoute = AuthRouteRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const MModuleKeyRouteRoute = MModuleKeyRouteRouteImport.update({
            id: '/m/$moduleKey',path: '/m/$moduleKey',getParentRoute: () => rootRouteImport
          })
const SettingsQuotasRoute = SettingsQuotasRouteImport.update({
            id: '/quotas',path: '/quotas',getParentRoute: () => SettingsRouteRoute
          })
const SettingsMarketplaceRoute = SettingsMarketplaceRouteImport.update({
            id: '/marketplace',path: '/marketplace',getParentRoute: () => SettingsRouteRoute
          })
const SettingsRolesRouteRoute = SettingsRolesRouteRouteImport.update({
            id: '/roles',path: '/roles',getParentRoute: () => SettingsRouteRoute
          })
const SettingsApiKeysRouteRoute = SettingsApiKeysRouteRouteImport.update({
            id: '/api-keys',path: '/api-keys',getParentRoute: () => SettingsRouteRoute
          })
const HrIndexRoute = HrIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HrRouteRoute
          })
const HrTrainingRouteRoute = HrTrainingRouteRouteImport.update({
            id: '/training',path: '/training',getParentRoute: () => HrRouteRoute
          })
const HrShiftsRouteRoute = HrShiftsRouteRouteImport.update({
            id: '/shifts',path: '/shifts',getParentRoute: () => HrRouteRoute
          })
const HrRecruitmentRouteRoute = HrRecruitmentRouteRouteImport.update({
            id: '/recruitment',path: '/recruitment',getParentRoute: () => HrRouteRoute
          })
const HrPerformanceReviewsRouteRoute = HrPerformanceReviewsRouteRouteImport.update({
            id: '/performance-reviews',path: '/performance-reviews',getParentRoute: () => HrRouteRoute
          })
const HrPayrollRouteRoute = HrPayrollRouteRouteImport.update({
            id: '/payroll',path: '/payroll',getParentRoute: () => HrRouteRoute
          })
const HrOnboardingRouteRoute = HrOnboardingRouteRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => HrRouteRoute
          })
const HrMeRouteRoute = HrMeRouteRouteImport.update({
            id: '/me',path: '/me',getParentRoute: () => HrRouteRoute
          })
const HrLifecycleRouteRoute = HrLifecycleRouteRouteImport.update({
            id: '/lifecycle',path: '/lifecycle',getParentRoute: () => HrRouteRoute
          })
const HrLeaveRouteRoute = HrLeaveRouteRouteImport.update({
            id: '/leave',path: '/leave',getParentRoute: () => HrRouteRoute
          })
const HrExpenseClaimsRouteRoute = HrExpenseClaimsRouteRouteImport.update({
            id: '/expense-claims',path: '/expense-claims',getParentRoute: () => HrRouteRoute
          })
const HrEmployeesRouteRoute = HrEmployeesRouteRouteImport.update({
            id: '/employees',path: '/employees',getParentRoute: () => HrRouteRoute
          })
const HrDocumentsRouteRoute = HrDocumentsRouteRouteImport.update({
            id: '/documents',path: '/documents',getParentRoute: () => HrRouteRoute
          })
const HrDepartmentsRouteRoute = HrDepartmentsRouteRouteImport.update({
            id: '/departments',path: '/departments',getParentRoute: () => HrRouteRoute
          })
const HrContractsRouteRoute = HrContractsRouteRouteImport.update({
            id: '/contracts',path: '/contracts',getParentRoute: () => HrRouteRoute
          })
const HrAttendanceRouteRoute = HrAttendanceRouteRouteImport.update({
            id: '/attendance',path: '/attendance',getParentRoute: () => HrRouteRoute
          })
const CrmIndexRoute = CrmIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CrmRouteRoute
          })
const CrmOpportunitiesRouteRoute = CrmOpportunitiesRouteRouteImport.update({
            id: '/opportunities',path: '/opportunities',getParentRoute: () => CrmRouteRoute
          })
const CrmLeadsRouteRoute = CrmLeadsRouteRouteImport.update({
            id: '/leads',path: '/leads',getParentRoute: () => CrmRouteRoute
          })
const CrmContactsRouteRoute = CrmContactsRouteRouteImport.update({
            id: '/contacts',path: '/contacts',getParentRoute: () => CrmRouteRoute
          })
const CrmActivitiesRouteRoute = CrmActivitiesRouteRouteImport.update({
            id: '/activities',path: '/activities',getParentRoute: () => CrmRouteRoute
          })
const CrmAccountsRouteRoute = CrmAccountsRouteRouteImport.update({
            id: '/accounts',path: '/accounts',getParentRoute: () => CrmRouteRoute
          })
const MModuleKeyIndexRoute = MModuleKeyIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MModuleKeyRouteRoute
          })
const SettingsTeamsIndexRoute = SettingsTeamsIndexRouteImport.update({
            id: '/teams/',path: '/teams/',getParentRoute: () => SettingsRouteRoute
          })
const SettingsModulesIndexRoute = SettingsModulesIndexRouteImport.update({
            id: '/modules/',path: '/modules/',getParentRoute: () => SettingsRouteRoute
          })
const SettingsCustomModulesIndexRoute = SettingsCustomModulesIndexRouteImport.update({
            id: '/custom-modules/',path: '/custom-modules/',getParentRoute: () => SettingsRouteRoute
          })
const SettingsCalculationsIndexRoute = SettingsCalculationsIndexRouteImport.update({
            id: '/calculations/',path: '/calculations/',getParentRoute: () => SettingsRouteRoute
          })
const SettingsTeamsTeamIdRoute = SettingsTeamsTeamIdRouteImport.update({
            id: '/teams/$teamId',path: '/teams/$teamId',getParentRoute: () => SettingsRouteRoute
          })
const SettingsCustomModulesNewRoute = SettingsCustomModulesNewRouteImport.update({
            id: '/custom-modules/new',path: '/custom-modules/new',getParentRoute: () => SettingsRouteRoute
          })
const SettingsCrmWebhooksRoute = SettingsCrmWebhooksRouteImport.update({
            id: '/crm/webhooks',path: '/crm/webhooks',getParentRoute: () => SettingsRouteRoute
          })
const SettingsCrmPipelinesRoute = SettingsCrmPipelinesRouteImport.update({
            id: '/crm/pipelines',path: '/crm/pipelines',getParentRoute: () => SettingsRouteRoute
          })
const SettingsCrmLookupsRoute = SettingsCrmLookupsRouteImport.update({
            id: '/crm/lookups',path: '/crm/lookups',getParentRoute: () => SettingsRouteRoute
          })
const SettingsCrmCurrencySettingsRoute = SettingsCrmCurrencySettingsRouteImport.update({
            id: '/crm/currency-settings',path: '/crm/currency-settings',getParentRoute: () => SettingsRouteRoute
          })
const SettingsCrmCurrencyRatesRoute = SettingsCrmCurrencyRatesRouteImport.update({
            id: '/crm/currency-rates',path: '/crm/currency-rates',getParentRoute: () => SettingsRouteRoute
          })
const SettingsCalculationsNewRoute = SettingsCalculationsNewRouteImport.update({
            id: '/calculations/new',path: '/calculations/new',getParentRoute: () => SettingsRouteRoute
          })
const SettingsCalculationsKeyRoute = SettingsCalculationsKeyRouteImport.update({
            id: '/calculations/$key',path: '/calculations/$key',getParentRoute: () => SettingsRouteRoute
          })
const SettingsCustomModulesKeyRouteRoute = SettingsCustomModulesKeyRouteRouteImport.update({
            id: '/custom-modules/$key',path: '/custom-modules/$key',getParentRoute: () => SettingsRouteRoute
          })
const SettingsRolesIndexRoute = SettingsRolesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SettingsRolesRouteRoute
          })
const SettingsRolesUsersRoute = SettingsRolesUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => SettingsRolesRouteRoute
          })
const SettingsRolesNewRoute = SettingsRolesNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => SettingsRolesRouteRoute
          })
const SettingsRolesRoleKeyRoute = SettingsRolesRoleKeyRouteImport.update({
            id: '/$roleKey',path: '/$roleKey',getParentRoute: () => SettingsRolesRouteRoute
          })
const SettingsApiKeysIndexRoute = SettingsApiKeysIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SettingsApiKeysRouteRoute
          })
const SettingsApiKeysAuditRoute = SettingsApiKeysAuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => SettingsApiKeysRouteRoute
          })
const HrTrainingIndexRoute = HrTrainingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HrTrainingRouteRoute
          })
const HrTrainingEventIdRoute = HrTrainingEventIdRouteImport.update({
            id: '/$eventId',path: '/$eventId',getParentRoute: () => HrTrainingRouteRoute
          })
const HrShiftsIndexRoute = HrShiftsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HrShiftsRouteRoute
          })
const HrRecruitmentIndexRoute = HrRecruitmentIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HrRecruitmentRouteRoute
          })
const HrRecruitmentOpeningsRouteRoute = HrRecruitmentOpeningsRouteRouteImport.update({
            id: '/openings',path: '/openings',getParentRoute: () => HrRecruitmentRouteRoute
          })
const HrPerformanceReviewsReviewIdRoute = HrPerformanceReviewsReviewIdRouteImport.update({
            id: '/$reviewId',path: '/$reviewId',getParentRoute: () => HrPerformanceReviewsRouteRoute
          })
const HrPayrollIndexRoute = HrPayrollIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HrPayrollRouteRoute
          })
const HrPayrollComponentsRoute = HrPayrollComponentsRouteImport.update({
            id: '/components',path: '/components',getParentRoute: () => HrPayrollRouteRoute
          })
const HrPayrollStructuresRouteRoute = HrPayrollStructuresRouteRouteImport.update({
            id: '/structures',path: '/structures',getParentRoute: () => HrPayrollRouteRoute
          })
const HrPayrollRunsRouteRoute = HrPayrollRunsRouteRouteImport.update({
            id: '/runs',path: '/runs',getParentRoute: () => HrPayrollRouteRoute
          })
const HrMeIndexRoute = HrMeIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HrMeRouteRoute
          })
const HrMeProfileRoute = HrMeProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => HrMeRouteRoute
          })
const HrMePerformanceRoute = HrMePerformanceRouteImport.update({
            id: '/performance',path: '/performance',getParentRoute: () => HrMeRouteRoute
          })
const HrMePayslipsRoute = HrMePayslipsRouteImport.update({
            id: '/payslips',path: '/payslips',getParentRoute: () => HrMeRouteRoute
          })
const HrMeLeaveRoute = HrMeLeaveRouteImport.update({
            id: '/leave',path: '/leave',getParentRoute: () => HrMeRouteRoute
          })
const HrMeExpenseClaimsRoute = HrMeExpenseClaimsRouteImport.update({
            id: '/expense-claims',path: '/expense-claims',getParentRoute: () => HrMeRouteRoute
          })
const HrMeAttendanceRoute = HrMeAttendanceRouteImport.update({
            id: '/attendance',path: '/attendance',getParentRoute: () => HrMeRouteRoute
          })
const HrLifecycleIndexRoute = HrLifecycleIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HrLifecycleRouteRoute
          })
const HrExpenseClaimsIndexRoute = HrExpenseClaimsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HrExpenseClaimsRouteRoute
          })
const HrExpenseClaimsClaimIdRoute = HrExpenseClaimsClaimIdRouteImport.update({
            id: '/$claimId',path: '/$claimId',getParentRoute: () => HrExpenseClaimsRouteRoute
          })
const HrEmployeesIndexRoute = HrEmployeesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HrEmployeesRouteRoute
          })
const HrEmployeesEmployeeIdRoute = HrEmployeesEmployeeIdRouteImport.update({
            id: '/$employeeId',path: '/$employeeId',getParentRoute: () => HrEmployeesRouteRoute
          })
const HrDocumentsIndexRoute = HrDocumentsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HrDocumentsRouteRoute
          })
const HrContractsIndexRoute = HrContractsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HrContractsRouteRoute
          })
const HrContractsContractIdRoute = HrContractsContractIdRouteImport.update({
            id: '/$contractId',path: '/$contractId',getParentRoute: () => HrContractsRouteRoute
          })
const HrAttendanceIndexRoute = HrAttendanceIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HrAttendanceRouteRoute
          })
const HrAttendanceMarkRoute = HrAttendanceMarkRouteImport.update({
            id: '/mark',path: '/mark',getParentRoute: () => HrAttendanceRouteRoute
          })
const CrmOpportunitiesIndexRoute = CrmOpportunitiesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CrmOpportunitiesRouteRoute
          })
const CrmOpportunitiesNewRoute = CrmOpportunitiesNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => CrmOpportunitiesRouteRoute
          })
const CrmOpportunitiesOpportunityIdRoute = CrmOpportunitiesOpportunityIdRouteImport.update({
            id: '/$opportunityId',path: '/$opportunityId',getParentRoute: () => CrmOpportunitiesRouteRoute
          })
const CrmLeadsIndexRoute = CrmLeadsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CrmLeadsRouteRoute
          })
const CrmLeadsNewRoute = CrmLeadsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => CrmLeadsRouteRoute
          })
const CrmLeadsImportRoute = CrmLeadsImportRouteImport.update({
            id: '/import',path: '/import',getParentRoute: () => CrmLeadsRouteRoute
          })
const CrmLeadsLeadIdRoute = CrmLeadsLeadIdRouteImport.update({
            id: '/$leadId',path: '/$leadId',getParentRoute: () => CrmLeadsRouteRoute
          })
const CrmContactsIndexRoute = CrmContactsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CrmContactsRouteRoute
          })
const CrmContactsNewRoute = CrmContactsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => CrmContactsRouteRoute
          })
const CrmContactsContactIdRoute = CrmContactsContactIdRouteImport.update({
            id: '/$contactId',path: '/$contactId',getParentRoute: () => CrmContactsRouteRoute
          })
const CrmActivitiesIndexRoute = CrmActivitiesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CrmActivitiesRouteRoute
          })
const CrmAccountsIndexRoute = CrmAccountsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CrmAccountsRouteRoute
          })
const CrmAccountsNewRoute = CrmAccountsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => CrmAccountsRouteRoute
          })
const CrmAccountsAccountIdRoute = CrmAccountsAccountIdRouteImport.update({
            id: '/$accountId',path: '/$accountId',getParentRoute: () => CrmAccountsRouteRoute
          })
const MModuleKeyEntityKeyIndexRoute = MModuleKeyEntityKeyIndexRouteImport.update({
            id: '/$entityKey/',path: '/$entityKey/',getParentRoute: () => MModuleKeyRouteRoute
          })
const MModuleKeyEntityKeyNewRoute = MModuleKeyEntityKeyNewRouteImport.update({
            id: '/$entityKey/new',path: '/$entityKey/new',getParentRoute: () => MModuleKeyRouteRoute
          })
const SettingsCalculationsKeyRunRoute = SettingsCalculationsKeyRunRouteImport.update({
            id: '/run',path: '/run',getParentRoute: () => SettingsCalculationsKeyRoute
          })
const SettingsCustomModulesKeyIndexRoute = SettingsCustomModulesKeyIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SettingsCustomModulesKeyRouteRoute
          })
const SettingsCustomModulesKeyWebhooksRoute = SettingsCustomModulesKeyWebhooksRouteImport.update({
            id: '/webhooks',path: '/webhooks',getParentRoute: () => SettingsCustomModulesKeyRouteRoute
          })
const SettingsCustomModulesKeyPermissionsRoute = SettingsCustomModulesKeyPermissionsRouteImport.update({
            id: '/permissions',path: '/permissions',getParentRoute: () => SettingsCustomModulesKeyRouteRoute
          })
const SettingsCustomModulesKeyNavRoute = SettingsCustomModulesKeyNavRouteImport.update({
            id: '/nav',path: '/nav',getParentRoute: () => SettingsCustomModulesKeyRouteRoute
          })
const SettingsCustomModulesKeyAuditRoute = SettingsCustomModulesKeyAuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => SettingsCustomModulesKeyRouteRoute
          })
const HrRecruitmentApplicantsApplicantIdRoute = HrRecruitmentApplicantsApplicantIdRouteImport.update({
            id: '/applicants/$applicantId',path: '/applicants/$applicantId',getParentRoute: () => HrRecruitmentRouteRoute
          })
const HrRecruitmentOpeningsIndexRoute = HrRecruitmentOpeningsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HrRecruitmentOpeningsRouteRoute
          })
const HrRecruitmentOpeningsOpeningIdRoute = HrRecruitmentOpeningsOpeningIdRouteImport.update({
            id: '/$openingId',path: '/$openingId',getParentRoute: () => HrRecruitmentOpeningsRouteRoute
          })
const HrPayrollStructuresIndexRoute = HrPayrollStructuresIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HrPayrollStructuresRouteRoute
          })
const HrPayrollStructuresStructureIdRoute = HrPayrollStructuresStructureIdRouteImport.update({
            id: '/$structureId',path: '/$structureId',getParentRoute: () => HrPayrollStructuresRouteRoute
          })
const HrPayrollRunsIndexRoute = HrPayrollRunsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HrPayrollRunsRouteRoute
          })
const HrPayrollRunsRunIdRoute = HrPayrollRunsRunIdRouteImport.update({
            id: '/$runId',path: '/$runId',getParentRoute: () => HrPayrollRunsRouteRoute
          })
const CrmOpportunitiesOpportunityIdEditRoute = CrmOpportunitiesOpportunityIdEditRouteImport.update({
            id: '/edit',path: '/edit',getParentRoute: () => CrmOpportunitiesOpportunityIdRoute
          })
const CrmLeadsLeadIdEditRoute = CrmLeadsLeadIdEditRouteImport.update({
            id: '/edit',path: '/edit',getParentRoute: () => CrmLeadsLeadIdRoute
          })
const CrmLeadsLeadIdConvertRoute = CrmLeadsLeadIdConvertRouteImport.update({
            id: '/convert',path: '/convert',getParentRoute: () => CrmLeadsLeadIdRoute
          })
const CrmContactsContactIdEditRoute = CrmContactsContactIdEditRouteImport.update({
            id: '/edit',path: '/edit',getParentRoute: () => CrmContactsContactIdRoute
          })
const CrmAccountsAccountIdEditRoute = CrmAccountsAccountIdEditRouteImport.update({
            id: '/edit',path: '/edit',getParentRoute: () => CrmAccountsAccountIdRoute
          })
const MModuleKeyEntityKeyRecordIdIndexRoute = MModuleKeyEntityKeyRecordIdIndexRouteImport.update({
            id: '/$entityKey/$recordId/',path: '/$entityKey/$recordId/',getParentRoute: () => MModuleKeyRouteRoute
          })
const MModuleKeyEntityKeyRecordIdEditRoute = MModuleKeyEntityKeyRecordIdEditRouteImport.update({
            id: '/$entityKey/$recordId/edit',path: '/$entityKey/$recordId/edit',getParentRoute: () => MModuleKeyRouteRoute
          })
const SettingsExtensionsModuleKeyEntityKeyViewsRoute = SettingsExtensionsModuleKeyEntityKeyViewsRouteImport.update({
            id: '/extensions/$moduleKey/$entityKey/views',path: '/extensions/$moduleKey/$entityKey/views',getParentRoute: () => SettingsRouteRoute
          })
const SettingsExtensionsModuleKeyEntityKeyLayoutRoute = SettingsExtensionsModuleKeyEntityKeyLayoutRouteImport.update({
            id: '/extensions/$moduleKey/$entityKey/layout',path: '/extensions/$moduleKey/$entityKey/layout',getParentRoute: () => SettingsRouteRoute
          })
const SettingsExtensionsModuleKeyEntityKeyFieldsRoute = SettingsExtensionsModuleKeyEntityKeyFieldsRouteImport.update({
            id: '/extensions/$moduleKey/$entityKey/fields',path: '/extensions/$moduleKey/$entityKey/fields',getParentRoute: () => SettingsRouteRoute
          })
const SettingsCustomModulesKeyWorkflowsIndexRoute = SettingsCustomModulesKeyWorkflowsIndexRouteImport.update({
            id: '/workflows/',path: '/workflows/',getParentRoute: () => SettingsCustomModulesKeyRouteRoute
          })
const SettingsCustomModulesKeyEntitiesIndexRoute = SettingsCustomModulesKeyEntitiesIndexRouteImport.update({
            id: '/entities/',path: '/entities/',getParentRoute: () => SettingsCustomModulesKeyRouteRoute
          })
const SettingsCustomModulesKeyWorkflowsNewRoute = SettingsCustomModulesKeyWorkflowsNewRouteImport.update({
            id: '/workflows/new',path: '/workflows/new',getParentRoute: () => SettingsCustomModulesKeyRouteRoute
          })
const SettingsCustomModulesKeyWorkflowsWorkflowKeyRoute = SettingsCustomModulesKeyWorkflowsWorkflowKeyRouteImport.update({
            id: '/workflows/$workflowKey',path: '/workflows/$workflowKey',getParentRoute: () => SettingsCustomModulesKeyRouteRoute
          })
const SettingsCustomModulesKeyEntitiesNewRoute = SettingsCustomModulesKeyEntitiesNewRouteImport.update({
            id: '/entities/new',path: '/entities/new',getParentRoute: () => SettingsCustomModulesKeyRouteRoute
          })
const SettingsCustomModulesKeyEntitiesEntityKeyRoute = SettingsCustomModulesKeyEntitiesEntityKeyRouteImport.update({
            id: '/entities/$entityKey',path: '/entities/$entityKey',getParentRoute: () => SettingsCustomModulesKeyRouteRoute
          })





const CrmAccountsAccountIdRouteChildren = {
  CrmAccountsAccountIdEditRoute: CrmAccountsAccountIdEditRoute
}

const CrmAccountsAccountIdRouteWithChildren = CrmAccountsAccountIdRoute._addFileChildren(CrmAccountsAccountIdRouteChildren)



const CrmAccountsRouteRouteChildren = {
  CrmAccountsAccountIdRoute: CrmAccountsAccountIdRouteWithChildren,CrmAccountsNewRoute: CrmAccountsNewRoute,CrmAccountsIndexRoute: CrmAccountsIndexRoute
}

const CrmAccountsRouteRouteWithChildren = CrmAccountsRouteRoute._addFileChildren(CrmAccountsRouteRouteChildren)




const CrmActivitiesRouteRouteChildren = {
  CrmActivitiesIndexRoute: CrmActivitiesIndexRoute
}

const CrmActivitiesRouteRouteWithChildren = CrmActivitiesRouteRoute._addFileChildren(CrmActivitiesRouteRouteChildren)




const CrmContactsContactIdRouteChildren = {
  CrmContactsContactIdEditRoute: CrmContactsContactIdEditRoute
}

const CrmContactsContactIdRouteWithChildren = CrmContactsContactIdRoute._addFileChildren(CrmContactsContactIdRouteChildren)



const CrmContactsRouteRouteChildren = {
  CrmContactsContactIdRoute: CrmContactsContactIdRouteWithChildren,CrmContactsNewRoute: CrmContactsNewRoute,CrmContactsIndexRoute: CrmContactsIndexRoute
}

const CrmContactsRouteRouteWithChildren = CrmContactsRouteRoute._addFileChildren(CrmContactsRouteRouteChildren)




const CrmLeadsLeadIdRouteChildren = {
  CrmLeadsLeadIdConvertRoute: CrmLeadsLeadIdConvertRoute,CrmLeadsLeadIdEditRoute: CrmLeadsLeadIdEditRoute
}

const CrmLeadsLeadIdRouteWithChildren = CrmLeadsLeadIdRoute._addFileChildren(CrmLeadsLeadIdRouteChildren)



const CrmLeadsRouteRouteChildren = {
  CrmLeadsLeadIdRoute: CrmLeadsLeadIdRouteWithChildren,CrmLeadsImportRoute: CrmLeadsImportRoute,CrmLeadsNewRoute: CrmLeadsNewRoute,CrmLeadsIndexRoute: CrmLeadsIndexRoute
}

const CrmLeadsRouteRouteWithChildren = CrmLeadsRouteRoute._addFileChildren(CrmLeadsRouteRouteChildren)




const CrmOpportunitiesOpportunityIdRouteChildren = {
  CrmOpportunitiesOpportunityIdEditRoute: CrmOpportunitiesOpportunityIdEditRoute
}

const CrmOpportunitiesOpportunityIdRouteWithChildren = CrmOpportunitiesOpportunityIdRoute._addFileChildren(CrmOpportunitiesOpportunityIdRouteChildren)



const CrmOpportunitiesRouteRouteChildren = {
  CrmOpportunitiesOpportunityIdRoute: CrmOpportunitiesOpportunityIdRouteWithChildren,CrmOpportunitiesNewRoute: CrmOpportunitiesNewRoute,CrmOpportunitiesIndexRoute: CrmOpportunitiesIndexRoute
}

const CrmOpportunitiesRouteRouteWithChildren = CrmOpportunitiesRouteRoute._addFileChildren(CrmOpportunitiesRouteRouteChildren)



const CrmRouteRouteChildren = {
  CrmAccountsRouteRoute: CrmAccountsRouteRouteWithChildren,CrmActivitiesRouteRoute: CrmActivitiesRouteRouteWithChildren,CrmContactsRouteRoute: CrmContactsRouteRouteWithChildren,CrmLeadsRouteRoute: CrmLeadsRouteRouteWithChildren,CrmOpportunitiesRouteRoute: CrmOpportunitiesRouteRouteWithChildren,CrmIndexRoute: CrmIndexRoute
}

const CrmRouteRouteWithChildren = CrmRouteRoute._addFileChildren(CrmRouteRouteChildren)




const HrAttendanceRouteRouteChildren = {
  HrAttendanceMarkRoute: HrAttendanceMarkRoute,HrAttendanceIndexRoute: HrAttendanceIndexRoute
}

const HrAttendanceRouteRouteWithChildren = HrAttendanceRouteRoute._addFileChildren(HrAttendanceRouteRouteChildren)




const HrContractsRouteRouteChildren = {
  HrContractsContractIdRoute: HrContractsContractIdRoute,HrContractsIndexRoute: HrContractsIndexRoute
}

const HrContractsRouteRouteWithChildren = HrContractsRouteRoute._addFileChildren(HrContractsRouteRouteChildren)




const HrDocumentsRouteRouteChildren = {
  HrDocumentsIndexRoute: HrDocumentsIndexRoute
}

const HrDocumentsRouteRouteWithChildren = HrDocumentsRouteRoute._addFileChildren(HrDocumentsRouteRouteChildren)




const HrEmployeesRouteRouteChildren = {
  HrEmployeesEmployeeIdRoute: HrEmployeesEmployeeIdRoute,HrEmployeesIndexRoute: HrEmployeesIndexRoute
}

const HrEmployeesRouteRouteWithChildren = HrEmployeesRouteRoute._addFileChildren(HrEmployeesRouteRouteChildren)




const HrExpenseClaimsRouteRouteChildren = {
  HrExpenseClaimsClaimIdRoute: HrExpenseClaimsClaimIdRoute,HrExpenseClaimsIndexRoute: HrExpenseClaimsIndexRoute
}

const HrExpenseClaimsRouteRouteWithChildren = HrExpenseClaimsRouteRoute._addFileChildren(HrExpenseClaimsRouteRouteChildren)




const HrLifecycleRouteRouteChildren = {
  HrLifecycleIndexRoute: HrLifecycleIndexRoute
}

const HrLifecycleRouteRouteWithChildren = HrLifecycleRouteRoute._addFileChildren(HrLifecycleRouteRouteChildren)




const HrMeRouteRouteChildren = {
  HrMeAttendanceRoute: HrMeAttendanceRoute,HrMeExpenseClaimsRoute: HrMeExpenseClaimsRoute,HrMeLeaveRoute: HrMeLeaveRoute,HrMePayslipsRoute: HrMePayslipsRoute,HrMePerformanceRoute: HrMePerformanceRoute,HrMeProfileRoute: HrMeProfileRoute,HrMeIndexRoute: HrMeIndexRoute
}

const HrMeRouteRouteWithChildren = HrMeRouteRoute._addFileChildren(HrMeRouteRouteChildren)




const HrPayrollRunsRouteRouteChildren = {
  HrPayrollRunsRunIdRoute: HrPayrollRunsRunIdRoute,HrPayrollRunsIndexRoute: HrPayrollRunsIndexRoute
}

const HrPayrollRunsRouteRouteWithChildren = HrPayrollRunsRouteRoute._addFileChildren(HrPayrollRunsRouteRouteChildren)




const HrPayrollStructuresRouteRouteChildren = {
  HrPayrollStructuresStructureIdRoute: HrPayrollStructuresStructureIdRoute,HrPayrollStructuresIndexRoute: HrPayrollStructuresIndexRoute
}

const HrPayrollStructuresRouteRouteWithChildren = HrPayrollStructuresRouteRoute._addFileChildren(HrPayrollStructuresRouteRouteChildren)



const HrPayrollRouteRouteChildren = {
  HrPayrollRunsRouteRoute: HrPayrollRunsRouteRouteWithChildren,HrPayrollStructuresRouteRoute: HrPayrollStructuresRouteRouteWithChildren,HrPayrollComponentsRoute: HrPayrollComponentsRoute,HrPayrollIndexRoute: HrPayrollIndexRoute
}

const HrPayrollRouteRouteWithChildren = HrPayrollRouteRoute._addFileChildren(HrPayrollRouteRouteChildren)




const HrPerformanceReviewsRouteRouteChildren = {
  HrPerformanceReviewsReviewIdRoute: HrPerformanceReviewsReviewIdRoute
}

const HrPerformanceReviewsRouteRouteWithChildren = HrPerformanceReviewsRouteRoute._addFileChildren(HrPerformanceReviewsRouteRouteChildren)




const HrRecruitmentOpeningsRouteRouteChildren = {
  HrRecruitmentOpeningsOpeningIdRoute: HrRecruitmentOpeningsOpeningIdRoute,HrRecruitmentOpeningsIndexRoute: HrRecruitmentOpeningsIndexRoute
}

const HrRecruitmentOpeningsRouteRouteWithChildren = HrRecruitmentOpeningsRouteRoute._addFileChildren(HrRecruitmentOpeningsRouteRouteChildren)



const HrRecruitmentRouteRouteChildren = {
  HrRecruitmentOpeningsRouteRoute: HrRecruitmentOpeningsRouteRouteWithChildren,HrRecruitmentIndexRoute: HrRecruitmentIndexRoute,HrRecruitmentApplicantsApplicantIdRoute: HrRecruitmentApplicantsApplicantIdRoute
}

const HrRecruitmentRouteRouteWithChildren = HrRecruitmentRouteRoute._addFileChildren(HrRecruitmentRouteRouteChildren)




const HrShiftsRouteRouteChildren = {
  HrShiftsIndexRoute: HrShiftsIndexRoute
}

const HrShiftsRouteRouteWithChildren = HrShiftsRouteRoute._addFileChildren(HrShiftsRouteRouteChildren)




const HrTrainingRouteRouteChildren = {
  HrTrainingEventIdRoute: HrTrainingEventIdRoute,HrTrainingIndexRoute: HrTrainingIndexRoute
}

const HrTrainingRouteRouteWithChildren = HrTrainingRouteRoute._addFileChildren(HrTrainingRouteRouteChildren)



const HrRouteRouteChildren = {
  HrAttendanceRouteRoute: HrAttendanceRouteRouteWithChildren,HrContractsRouteRoute: HrContractsRouteRouteWithChildren,HrDepartmentsRouteRoute: HrDepartmentsRouteRoute,HrDocumentsRouteRoute: HrDocumentsRouteRouteWithChildren,HrEmployeesRouteRoute: HrEmployeesRouteRouteWithChildren,HrExpenseClaimsRouteRoute: HrExpenseClaimsRouteRouteWithChildren,HrLeaveRouteRoute: HrLeaveRouteRoute,HrLifecycleRouteRoute: HrLifecycleRouteRouteWithChildren,HrMeRouteRoute: HrMeRouteRouteWithChildren,HrOnboardingRouteRoute: HrOnboardingRouteRoute,HrPayrollRouteRoute: HrPayrollRouteRouteWithChildren,HrPerformanceReviewsRouteRoute: HrPerformanceReviewsRouteRouteWithChildren,HrRecruitmentRouteRoute: HrRecruitmentRouteRouteWithChildren,HrShiftsRouteRoute: HrShiftsRouteRouteWithChildren,HrTrainingRouteRoute: HrTrainingRouteRouteWithChildren,HrIndexRoute: HrIndexRoute
}

const HrRouteRouteWithChildren = HrRouteRoute._addFileChildren(HrRouteRouteChildren)




const SettingsApiKeysRouteRouteChildren = {
  SettingsApiKeysAuditRoute: SettingsApiKeysAuditRoute,SettingsApiKeysIndexRoute: SettingsApiKeysIndexRoute
}

const SettingsApiKeysRouteRouteWithChildren = SettingsApiKeysRouteRoute._addFileChildren(SettingsApiKeysRouteRouteChildren)




const SettingsRolesRouteRouteChildren = {
  SettingsRolesRoleKeyRoute: SettingsRolesRoleKeyRoute,SettingsRolesNewRoute: SettingsRolesNewRoute,SettingsRolesUsersRoute: SettingsRolesUsersRoute,SettingsRolesIndexRoute: SettingsRolesIndexRoute
}

const SettingsRolesRouteRouteWithChildren = SettingsRolesRouteRoute._addFileChildren(SettingsRolesRouteRouteChildren)




const SettingsCustomModulesKeyRouteRouteChildren = {
  SettingsCustomModulesKeyAuditRoute: SettingsCustomModulesKeyAuditRoute,SettingsCustomModulesKeyNavRoute: SettingsCustomModulesKeyNavRoute,SettingsCustomModulesKeyPermissionsRoute: SettingsCustomModulesKeyPermissionsRoute,SettingsCustomModulesKeyWebhooksRoute: SettingsCustomModulesKeyWebhooksRoute,SettingsCustomModulesKeyIndexRoute: SettingsCustomModulesKeyIndexRoute,SettingsCustomModulesKeyEntitiesEntityKeyRoute: SettingsCustomModulesKeyEntitiesEntityKeyRoute,SettingsCustomModulesKeyEntitiesNewRoute: SettingsCustomModulesKeyEntitiesNewRoute,SettingsCustomModulesKeyWorkflowsWorkflowKeyRoute: SettingsCustomModulesKeyWorkflowsWorkflowKeyRoute,SettingsCustomModulesKeyWorkflowsNewRoute: SettingsCustomModulesKeyWorkflowsNewRoute,SettingsCustomModulesKeyEntitiesIndexRoute: SettingsCustomModulesKeyEntitiesIndexRoute,SettingsCustomModulesKeyWorkflowsIndexRoute: SettingsCustomModulesKeyWorkflowsIndexRoute
}

const SettingsCustomModulesKeyRouteRouteWithChildren = SettingsCustomModulesKeyRouteRoute._addFileChildren(SettingsCustomModulesKeyRouteRouteChildren)




const SettingsCalculationsKeyRouteChildren = {
  SettingsCalculationsKeyRunRoute: SettingsCalculationsKeyRunRoute
}

const SettingsCalculationsKeyRouteWithChildren = SettingsCalculationsKeyRoute._addFileChildren(SettingsCalculationsKeyRouteChildren)



const SettingsRouteRouteChildren = {
  SettingsApiKeysRouteRoute: SettingsApiKeysRouteRouteWithChildren,SettingsRolesRouteRoute: SettingsRolesRouteRouteWithChildren,SettingsMarketplaceRoute: SettingsMarketplaceRoute,SettingsQuotasRoute: SettingsQuotasRoute,SettingsCustomModulesKeyRouteRoute: SettingsCustomModulesKeyRouteRouteWithChildren,SettingsCalculationsKeyRoute: SettingsCalculationsKeyRouteWithChildren,SettingsCalculationsNewRoute: SettingsCalculationsNewRoute,SettingsCrmCurrencyRatesRoute: SettingsCrmCurrencyRatesRoute,SettingsCrmCurrencySettingsRoute: SettingsCrmCurrencySettingsRoute,SettingsCrmLookupsRoute: SettingsCrmLookupsRoute,SettingsCrmPipelinesRoute: SettingsCrmPipelinesRoute,SettingsCrmWebhooksRoute: SettingsCrmWebhooksRoute,SettingsCustomModulesNewRoute: SettingsCustomModulesNewRoute,SettingsTeamsTeamIdRoute: SettingsTeamsTeamIdRoute,SettingsCalculationsIndexRoute: SettingsCalculationsIndexRoute,SettingsCustomModulesIndexRoute: SettingsCustomModulesIndexRoute,SettingsModulesIndexRoute: SettingsModulesIndexRoute,SettingsTeamsIndexRoute: SettingsTeamsIndexRoute,SettingsExtensionsModuleKeyEntityKeyFieldsRoute: SettingsExtensionsModuleKeyEntityKeyFieldsRoute,SettingsExtensionsModuleKeyEntityKeyLayoutRoute: SettingsExtensionsModuleKeyEntityKeyLayoutRoute,SettingsExtensionsModuleKeyEntityKeyViewsRoute: SettingsExtensionsModuleKeyEntityKeyViewsRoute
}

const SettingsRouteRouteWithChildren = SettingsRouteRoute._addFileChildren(SettingsRouteRouteChildren)




const MModuleKeyRouteRouteChildren = {
  MModuleKeyIndexRoute: MModuleKeyIndexRoute,MModuleKeyEntityKeyNewRoute: MModuleKeyEntityKeyNewRoute,MModuleKeyEntityKeyIndexRoute: MModuleKeyEntityKeyIndexRoute,MModuleKeyEntityKeyRecordIdEditRoute: MModuleKeyEntityKeyRecordIdEditRoute,MModuleKeyEntityKeyRecordIdIndexRoute: MModuleKeyEntityKeyRecordIdIndexRoute
}

const MModuleKeyRouteRouteWithChildren = MModuleKeyRouteRoute._addFileChildren(MModuleKeyRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthRouteRoute: AuthRouteRoute,CrmRouteRoute: CrmRouteRouteWithChildren,DashboardRouteRoute: DashboardRouteRoute,HrRouteRoute: HrRouteRouteWithChildren,SettingsRouteRoute: SettingsRouteRouteWithChildren,R401Route: R401Route,R404Route: R404Route,ComingSoonRoute: ComingSoonRoute,ConfigRoute: ConfigRoute,ForgotPasswordRoute: ForgotPasswordRoute,LoginRoute: LoginRoute,MaintenanceRoute: MaintenanceRoute,RegisterRoute: RegisterRoute,ResetPasswordRoute: ResetPasswordRoute,Setup2faRoute: Setup2faRoute,UsersRoute: UsersRoute,MModuleKeyRouteRoute: MModuleKeyRouteRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)